import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { Uuid } from 'src/apis/api-utilities';
import type {
  HydrogenNetworkPointOrBundle,
  OptionalUrlTemplate,
  UrlTemplate,
} from 'src/apis/hydrogen-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

type HookParams = {
  networkPointOrBundleId: Uuid;
} & OptionalUrlTemplate;

type RequestParams = {
  networkPointOrBundleId: Uuid;
} & UrlTemplate;

export function useHydrogenNetworkPointOrBundle({
  url,
  networkPointOrBundleId,
}: HookParams) {
  const request = useAxios(
    (axios, baseConfig, { url, networkPointOrBundleId }: RequestParams) =>
      axios.request<HydrogenNetworkPointOrBundle>({
        ...baseConfig,
        url: urlTemplate.parse(url).expand({ networkPointOrBundleId }),
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url, networkPointOrBundleId });
    // oxlint-disable-next-line exhaustive-deps
  }, [url, networkPointOrBundleId]);

  return request;
}

export type HydrogenNetworkPointOrBundleRequest = ReturnType<
  typeof useHydrogenNetworkPointOrBundle
>;
